import React from 'react';
import { motion } from 'framer-motion';

const Terms = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.5 }
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-red-50/30 via-white to-gray-50/20">
        <div className="container mx-auto px-4 lg:px-8">
          <motion.div className="max-w-4xl mx-auto" {...fadeInUp}>
            <h1 className="text-4xl sm:text-5xl font-bold mb-6 text-[#ed3237]">Terms of Service</h1>
            <p className="text-lg text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 lg:py-24">
        <div className="container mx-auto px-4 lg:px-8">
          <motion.div className="max-w-4xl mx-auto space-y-8 prose prose-lg" {...fadeInUp}>
            
            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">1. Agreement to Terms</h2>
              <p className="text-muted-foreground">
                By accessing and using the Big Bag Essentials website (bigbagessentials.in), you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using this site.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">2. Use License</h2>
              <p className="text-muted-foreground mb-4">
                Permission is granted to temporarily access the materials (information or software) on Big Bag Essentials' website for personal, non-commercial viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or public display</li>
                <li>Attempt to decompile or reverse engineer any software on the website</li>
                <li>Remove any copyright or proprietary notations from the materials</li>
                <li>Transfer the materials to another person or mirror the materials on any other server</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">3. Product Information and Pricing</h2>
              <p className="text-muted-foreground mb-4">
                We strive to provide accurate product descriptions and pricing information. However:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Product specifications may change without notice</li>
                <li>Pricing is subject to change and confirmation at the time of quotation</li>
                <li>Images and descriptions are for reference purposes only</li>
                <li>Actual product appearance may vary slightly from images displayed</li>
                <li>We reserve the right to correct any errors in pricing or product information</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">4. Quotations and Orders</h2>
              <p className="text-muted-foreground mb-4">
                All quotations provided are:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-2">
                <li>Valid for the period specified in the quotation</li>
                <li>Subject to availability of materials and capacity</li>
                <li>Subject to confirmation of order details</li>
                <li>Not binding until confirmed in writing by Big Bag Essentials</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">5. Quality Standards</h2>
              <p className="text-muted-foreground">
                Big Bag Essentials is committed to providing high-quality products. All products are manufactured according to industry standards and our internal quality control processes. Any quality concerns should be raised within 7 days of receipt of goods.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">6. Intellectual Property</h2>
              <p className="text-muted-foreground">
                The materials on Big Bag Essentials' website, including but not limited to text, graphics, logos, images, and software, are the property of Big Bag Essentials and are protected by intellectual property laws. Unauthorized use may violate copyright, trademark, and other laws.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">7. Disclaimer</h2>
              <p className="text-muted-foreground mb-4">
                The materials on Big Bag Essentials' website are provided on an 'as is' basis. Big Bag Essentials makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">8. Limitations</h2>
              <p className="text-muted-foreground">
                In no event shall Big Bag Essentials or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Big Bag Essentials' website.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">9. Third-Party Links</h2>
              <p className="text-muted-foreground">
                Our website may contain links to third-party websites. These links are provided for your convenience only. Big Bag Essentials has no control over the content of these sites and accepts no responsibility for them or for any loss or damage that may arise from your use of them.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">10. Modifications</h2>
              <p className="text-muted-foreground">
                Big Bag Essentials may revise these Terms of Service at any time without notice. By using this website, you agree to be bound by the current version of these Terms of Service.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">11. Governing Law</h2>
              <p className="text-muted-foreground">
                These Terms of Service are governed by and construed in accordance with the laws of India, and you irrevocably submit to the exclusive jurisdiction of the courts in Rajasthan, India.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-[#ed3237] mb-4">12. Contact Information</h2>
              <p className="text-muted-foreground mb-4">
                If you have any questions about these Terms of Service, please contact us:
              </p>
              <div className="bg-muted/30 p-6 rounded-lg">
                <p className="font-semibold mb-2">Big Bag Essentials</p>
                <p className="text-muted-foreground mb-1">Email: anandsharma@bigbagessential.in</p>
                <p className="text-muted-foreground mb-1">Phone: +91 70733 39922, +91 94140 16053</p>
                <p className="text-muted-foreground">Address: No. 31, Panchwati Colony, Gayatri Nagar, Beawar, Rajasthan - 305901, India</p>
              </div>
            </div>

          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
